import type { SendMessageRequest } from '@aws-sdk/client-sqs';
import { SQS } from '@aws-sdk/client-sqs';
import type { MessageOptions } from './sqs-types';

const sqs = new SQS();

export function sendSingleMessage<Payload>(payloadObject: Payload, queueUrl: string, options: MessageOptions = {}) {
  const sendMessageInput = buildSendMessageRequest(payloadObject, queueUrl, options);

  return sqs.sendMessage(sendMessageInput);
}

function buildSendMessageRequest<Payload>(payloadObject: Payload, queueUrl: string, options: MessageOptions = {}): SendMessageRequest {
  const { dedupeId, groupId } = options;
  const message = JSON.stringify(payloadObject);

  return {
    QueueUrl: queueUrl,
    MessageBody: message,
    MessageDeduplicationId: dedupeId,
    MessageGroupId: groupId,
  };
}